export default [
    'form.catalogue.values.files',
    'form.contactPerson.values.images',
    'form.article.values.images',
    'form.article.values.files',
    'form.article.values.publishAt',
    'form.article.values.categories',
    'form.product.values.images',
    'form.product.values.files',
    'form.machine.values.images',
    'form.machine.values.files',
    'form.users.values.images',
    'form.settings.values',
    'form.portal-contact.values.images',
    'form.portal-contact.values.photo',
    'form.company.values.images',
    'form.portal-contact.values.photo',
    'form.catalog.values.files',
    'form.courses.values.files',
    'form.courses.values.images',
    'form.service.values.images',
    'form.service.values.files',
    'form.machine-rent.values.image'
];


// WEBPACK FOOTER //
// ./web/src/store/ignoreMutationStates.js